var _circle, _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileBot = function SvgFileBot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 649.6 649.6"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 324.8,
    cy: 324.8,
    r: 324.8,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M452.1 287.5c0 126.5-111.9 158-192.4 158S92.5 400.6 92.5 290.9c0-121.9 89.9-192.5 170.4-192.5s189.2 48.5 189.2 189.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8ecf7",
    d: "M452.1 294.1c0 121.2-103 151.4-177 151.4s-153.8-43-153.8-148.2c0-116.7 82.7-184.4 156.8-184.4s174 46.6 174 181.2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 314.3,
    height: 184.69,
    x: 121.3,
    y: 200.9,
    fill: "#a1c1e5",
    rx: 88
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c9d8ef",
    d: "M463.9 294.1c0 128.7-114.6 146.2-114.6 146.2 78.8-54.7 88.6-96.2 88.6-142.5 0-54.9-9.8-112.7-87.6-178.2-13.1-11 113.6 48.9 113.6 174.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4c84c4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 14,
    d: "M267.9 150.2h21.2m-35.9 23.7h50.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7fa9da",
    d: "M428.1 293.2c0 92.5-117 97.9-78.3 78.4 50.6-25.6 56-65.1 56.1-78.4.2-10.9 0-43.3-56.1-78.4-23.5-14.6 78.3-6.1 78.3 78.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c84c4",
    d: "M347.7 218.9a70.2 70.2 0 0 1 70 70v8.7a70.3 70.3 0 0 1-70 70H209.3a70.3 70.3 0 0 1-70-70v-8.7a70.2 70.2 0 0 1 70-70zm0-18H209.3a88.3 88.3 0 0 0-88 88v8.7a88.3 88.3 0 0 0 88 88h138.4a88.3 88.3 0 0 0 88-88v-8.7a88.3 88.3 0 0 0-88-88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8ecf7",
    d: "M192.6 304.5a22.2 22.2 0 1 1 22.1-22.2 22.3 22.3 0 0 1-22.1 22.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c84c4",
    d: "M192.6 268.2a14.2 14.2 0 0 1 0 28.3 14.2 14.2 0 1 1 0-28.3m0-16a30.2 30.2 0 1 0 30.1 30.1 30.2 30.2 0 0 0-30.1-30.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8ecf7",
    d: "M364.4 304.5a22.2 22.2 0 1 1 22.2-22.2 22.2 22.2 0 0 1-22.2 22.2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c84c4",
    d: "M364.4 268.2a14.2 14.2 0 1 1-14.1 14.1 14.2 14.2 0 0 1 14.1-14.1m0-16a30.2 30.2 0 1 0 30.2 30.1 30.1 30.1 0 0 0-30.2-30.1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4c84c4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 14,
    d: "M253.2 329.1c0 1.1 25.3 21.8 50.6 2M145.6 88v73.8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.6,
    cy: 88,
    r: 15.2,
    fill: "#e8ecf7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c84c4",
    d: "M145.6 81.8a6.2 6.2 0 1 1-6.3 6.2 6.2 6.2 0 0 1 6.3-6.2m0-18A24.2 24.2 0 1 0 169.8 88a24.2 24.2 0 0 0-24.2-24.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4c84c4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 18,
    d: "M111.8 221.9a177 177 0 0 1 166.7-117.5c97.8 0 177 79.3 177 177s-33.5 166.1-177 166.1-177-68.3-177-166.1c0-3.1.1-6.3.3-9.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c84c4",
    d: "M105.4 254.3a8.7 8.7 0 1 1 8.7-8.7 8.7 8.7 0 0 1-8.7 8.7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M502.9 312.9 404 285.8a18.6 18.6 0 0 0-22.8 13l-59.9 218.7a18.5 18.5 0 0 0 13 22.8l148.9 40.8a18.6 18.6 0 0 0 22.9-13l46.2-168.6a5.7 5.7 0 0 0-.5-3.8l-45.9-80.4a4.8 4.8 0 0 0-3-2.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    stroke: "#6c522d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M324.9 359h72.5m-126.7 30.2h150.4M304 419.4h59.9m-108.4 37.2h99.1",
    opacity: 0.43
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    stroke: "#fbca66",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M327.9 356h72.5m-126.7 30.2h150.4M307 416.4h59.9m-108.4 37.2h99.1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#55c8e7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M443.2 323.3v26.1m-13-13.1h26.1m-166.5 161v26.1m-13.1-13h26.1m150.8-9.2 18.4 18.4m-18.4 0 18.4-18.4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4b3b5",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "m503.7 317.9-16 58.5a3.1 3.1 0 0 0 2.2 3.9l58.5 16"
  })));
};
export default SvgFileBot;